"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  ActionError: () => ActionError,
  CookieHandler: () => CookieHandler,
  Event: () => Event,
  FetchError: () => FetchError,
  Integration: () => Integration,
  PageError: () => PageError,
  RedactionHandler: () => RedactionHandler,
  SDK: () => SDK,
  defaultRedactionRules: () => defaultRedactionRules,
  rememberMeCookie: () => rememberMeCookie
});
module.exports = __toCommonJS(src_exports);

// src/constants/defaultSessionLifetime.ts
var DEFAULT_SESSION_LIFETIME = 7776e6;

// src/constants/rememberMeCookieKey.ts
var REMEMBER_ME_COOKIE_KEY = "__rememberMe";

// src/constants/sdkNotConfiguredErrorMessage.ts
var SDK_NOT_CONFIGURED_ERROR_MESSAGE = "The SDK has not been configured. Please call .configure on the base SDK before you call any other methods";

// src/library/DependencyContainer.ts
var DependencyContainer = class {
  _hasBeenConfigured;
  _cookieHandler;
  _redactHandler;
  constructor() {
    this._hasBeenConfigured = false;
  }
  hasBeenConfigured() {
    return this._hasBeenConfigured;
  }
  cookieHandler() {
    return this._cookieHandler;
  }
  redactHandler() {
    return this._redactHandler;
  }
  configure(config) {
    this._hasBeenConfigured = true;
    this._cookieHandler = config.cookieHandler;
    this._redactHandler = config.redactHandler;
  }
  throwIfDINotConfigured = () => {
    if (!this._hasBeenConfigured) {
      throw new Error(SDK_NOT_CONFIGURED_ERROR_MESSAGE);
    }
  };
};
var Wrapper = class {
  dependencyContainer;
  constructor() {
    this.dependencyContainer = new DependencyContainer();
  }
  getDependencyContainer = () => this.dependencyContainer;
};
var wrapper = new Wrapper();
var dependencyContainer = wrapper.getDependencyContainer;

// src/helpers/cookieManagement.ts
var rememberMeCookie = {
  /**
   * Gets the remember me cookie.
   *
   * @param {ServerOptions} [serverOptions] - An optional {@link ServerOptions} object containing the res and req objects for ServerResponse and IncomingMessage with cookies respectively. Required for server-side rendering session management.
   *
   * @returns {Promise<boolean>} A boolean indicating whether or not the user is to be remembered.
   */
  get: async function(serverOptions) {
    dependencyContainer().throwIfDINotConfigured();
    const rememberMe = await dependencyContainer().cookieHandler().getCookie(REMEMBER_ME_COOKIE_KEY, serverOptions);
    return !!rememberMe;
  },
  /**
   * Sets the remember me cookie.
   *
   * @param {boolean} rememberMe - The value in which to set the remember me cookie.
   * @param {ServerOptions} [serverOptions] - An optional {@link ServerOptions} object containing the res and req objects for ServerResponse and IncomingMessage with cookies respectively. Required for server-side rendering session management.
   *
   * @returns {Promise<void>} Void.
   */
  set: async function(rememberMe, serverOptions) {
    dependencyContainer().throwIfDINotConfigured();
    if (rememberMe) {
      await dependencyContainer().cookieHandler().setCookie(REMEMBER_ME_COOKIE_KEY, "1", serverOptions);
    } else {
      await this.remove();
    }
  },
  /**
   * Removes the remember me cookie.
   *
   * @param {ServerOptions} [serverOptions] - An optional {@link ServerOptions} object containing the res and req objects for ServerResponse and IncomingMessage with cookies respectively. Required for server-side rendering session management.
   *
   * @returns {Promise<void>} Void.
   */
  remove: async function(serverOptions) {
    dependencyContainer().throwIfDINotConfigured();
    await dependencyContainer().cookieHandler().deleteCookie(REMEMBER_ME_COOKIE_KEY, serverOptions);
  }
};

// src/library/Integration.ts
var Integration = class {
  /**
   * The sdk instance passed and assigned in the constructor.
   */
  sdk;
  /**
   * Contructor.
   *
   * @param {SDK} sdk - The singleton sdk instance created within your project.
   */
  constructor(sdk) {
    this.sdk = sdk;
  }
};

// src/helpers/fetcher.ts
var fetcher = async (url, options, serverOptions, sessionLifetime) => {
  dependencyContainer().throwIfDINotConfigured();
  let sessionCookie = await dependencyContainer().cookieHandler().getCookie("frontastic-session", serverOptions);
  sessionCookie = sessionCookie ?? "";
  const incomingHeaders = serverOptions?.req ? { ...serverOptions.req.headers } : {};
  delete incomingHeaders["host"];
  delete incomingHeaders["cookie"];
  options.headers = {
    "Content-Type": "application/json",
    Accept: "application/json",
    "X-Frontastic-Access-Token": "APIKEY",
    ...options.headers || {},
    ...sessionCookie ? { "Frontastic-Session": sessionCookie } : {},
    ...incomingHeaders
  };
  const response = await fetch(url, options);
  const frontasticRequestId = response.headers.get("Frontastic-Request-Id") ?? "";
  if (response.ok && response.headers.has("Frontastic-Session")) {
    let rememberMe = await rememberMeCookie.get();
    let expiryDate;
    if (rememberMe) {
      expiryDate = new Date(
        Date.now() + (sessionLifetime ?? DEFAULT_SESSION_LIFETIME)
      );
    }
    await dependencyContainer().cookieHandler().setCookie(
      "frontastic-session",
      response.headers.get("Frontastic-Session"),
      { expires: expiryDate, ...serverOptions ?? {} }
    );
  }
  let error;
  if (response.ok) {
    try {
      let data = await response.json();
      return { frontasticRequestId, data, isError: false };
    } catch (err) {
      error = err;
    }
  } else {
    try {
      error = await response.clone().json();
    } catch (e) {
      error = await response.text();
    }
  }
  return { frontasticRequestId, error, isError: true };
};

// src/library/Queue.ts
var Queue = class {
  queue = [];
  promisePending = false;
  stopped = false;
  add(promise) {
    return new Promise((resolve, reject) => {
      this.queue.push({
        promise,
        resolve,
        reject
      });
      this.handle();
    });
  }
  stop() {
    this.stopped = true;
  }
  restart() {
    this.stopped = false;
    this.handle();
  }
  handle() {
    if (this.promisePending || this.stopped) {
      return;
    }
    const item = this.queue.shift();
    if (!item) {
      return;
    }
    try {
      this.promisePending = true;
      item.promise().then((value) => this.resolve(() => item.resolve(value))).catch((err) => this.resolve(() => item.reject(err)));
    } catch (err) {
      this.resolve(() => item.reject(err));
    }
  }
  resolve(callback) {
    this.promisePending = false;
    callback();
    this.handle();
  }
};

// src/library/Event.ts
var Event = class {
  /**
   * The name of the event, will match the key of the specific event.
   */
  eventName;
  /**
   * The data associated with the event, will match the value of the specific event and be the parameter supplied to the event handler.
   */
  data;
  /**
   * Contructor.
   *
   * @param {EventName} options.eventName - The name of the event being created, will match the key of the specific event.
   * @param {EventData} options.data - The data associated with the event being created, will match the value of the specific event and be the parameter supplied to the event handler.
   */
  constructor(options) {
    this.eventName = options.eventName;
    this.data = options.data;
  }
};

// src/library/EventManager.ts
var EventManager = class {
  eventHandlers;
  constructor() {
    this.eventHandlers = {};
  }
  getEventHandlers(eventName) {
    let eventHandlers = this.eventHandlers[eventName];
    if (eventHandlers === void 0) {
      eventHandlers = [];
      this.eventHandlers[eventName] = eventHandlers;
    }
    return eventHandlers;
  }
  /**
   * Adds an event handler for a pre-defined event.
   *
   * @param {EventName} eventName - The name of the event, will match the key of the specific event.
   * @param {(event: Event<EventName, Events[EventName]>) => void} handler - The handler function to be called when the event is triggered.
   */
  on(eventName, handler) {
    let eventHandlers = this.getEventHandlers(eventName);
    eventHandlers.push(handler);
  }
  /**
   * Removes an event handler for a pre-defined event.
   *
   * @param {EventName} eventName - The name of the event, will match the key of the specific event.
   * @param {(event: Event<EventName, Events[EventName]>) => void} handler - The handler function instance to be removed.
   */
  off(eventName, handler) {
    let eventHandlers = this.getEventHandlers(eventName);
    eventHandlers.splice(eventHandlers.indexOf(handler), 1);
  }
  /**
   * Triggers a pre-defined event.
   *
   * @param {Event<EventName, Events[EventName]>} event - The event to be triggered.
   */
  trigger(event) {
    for (let handler of this.getEventHandlers(event.eventName)) {
      handler(event);
    }
  }
};

// src/library/FetchError.ts
var FetchError = class extends Error {
  /**
   * The message associated with the error.
   */
  message;
  /**
   * Constructor.
   *
   * @param {string | Error} options.error - The error message or object detected.
   */
  constructor(options) {
    super();
    const error = options.error;
    if (typeof error === "string") {
      this.message = error;
    } else {
      Object.getOwnPropertyNames(error).forEach((key) => {
        this[key] = error[key];
      });
    }
  }
};

// src/library/ActionError.ts
var ActionError = class extends FetchError {
  /**
   * Constructor.
   *
   * @param {string | Error} options.error - The error returned from the internal fetcher.
   */
  constructor(options) {
    super(options);
  }
};

// src/helpers/urlHelpers.ts
var import_qs = __toESM(require("qs"));
var normaliseUrl = function(url) {
  let protocolSplit = url.split("//");
  let normalisedUrl = "";
  if (protocolSplit[0] && (protocolSplit[0] === "http:" || protocolSplit[0] === "https:" || protocolSplit[0] === "ws:" || protocolSplit[0] === "wss:")) {
    normalisedUrl = `${protocolSplit[0]}//`;
    protocolSplit.splice(0, 1);
  }
  let query = "";
  let querySplit = protocolSplit.join("//").split("?");
  if (querySplit.length > 1) {
    query = `?${querySplit.slice(1, querySplit.length).join("?")}`;
  }
  const pathSplit = querySplit[0].split("/");
  for (let n = 0; n < pathSplit.length; n++) {
    if (pathSplit[n]) {
      normalisedUrl += `${pathSplit[n]}/`;
    }
  }
  normalisedUrl = normalisedUrl.substring(0, normalisedUrl.length - 1);
  return normalisedUrl + query;
};
var toQueryObject = function(key, value) {
  let obj = {};
  obj[key] = value;
  return obj;
};
var toQueryString = function(obj) {
  return import_qs.default.stringify(obj, {
    arrayFormat: "indices",
    encodeValuesOnly: true,
    format: "RFC3986"
  });
};
var generateQueryString = function(query) {
  let queryString = "?";
  Object.keys(query).forEach((key) => {
    let value = query[key];
    if (value !== void 0 && typeof value !== "function") {
      if (value === null) {
        queryString += `${key}=null&`;
      } else {
        queryString += `${toQueryString(toQueryObject(key, value))}&`;
      }
    }
  });
  queryString = queryString.substring(0, queryString.length - 1);
  return queryString;
};
var isValidUrl = function(urlLike) {
  let url;
  try {
    url = new URL(urlLike);
  } catch (_) {
    return false;
  }
  return true;
};

// src/library/CookieHandler.ts
var import_cookie = require("cookie");
var CookieHandler = class {
  isClientSide() {
    return typeof window !== "undefined";
  }
  stringify(value = "") {
    try {
      const result = JSON.stringify(value);
      return /^[\{\[]/.test(result) ? result : value;
    } catch (e) {
      return value;
    }
  }
  decode(str) {
    return str ? str.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent) : str;
  }
  processValue(value) {
    switch (value) {
      case "true":
        return true;
      case "false":
        return false;
      case "undefined":
        return void 0;
      case "null":
        return null;
      default:
        return value;
    }
  }
  async getCookies(options) {
    let req;
    if (options) {
      req = options.req;
    }
    if (!this.isClientSide()) {
      if (req?.cookies) {
        return req.cookies;
      }
      if (req?.headers?.cookie) {
        return (0, import_cookie.parse)(req.headers.cookie);
      }
      return {};
    }
    const _cookies = {};
    const documentCookies = document.cookie ? document.cookie.split("; ") : [];
    for (let i = 0, len = documentCookies.length; i < len; i++) {
      const cookieParts = documentCookies[i].split("=");
      const _cookie = cookieParts.slice(1).join("=");
      const name = cookieParts[0];
      _cookies[name] = _cookie;
    }
    return _cookies;
  }
  async hasCookie(key, options) {
    if (!key) {
      return false;
    }
    const cookie = await this.getCookies(options);
    return cookie.hasOwnProperty(key);
  }
  async setCookie(key, data, options) {
    let _cookieOptions = {
      secure: true
    };
    let _req;
    let _res;
    if (options) {
      const { req, res, ..._options } = options;
      _req = req;
      _res = res;
      _cookieOptions = Object.assign({}, _options, _cookieOptions);
    }
    const cookieStr = (0, import_cookie.serialize)(key, this.stringify(data), {
      path: "/",
      ..._cookieOptions
    });
    if (!this.isClientSide()) {
      if (_res && _req) {
        let currentCookies = _res.getHeader("Set-Cookie");
        if (!Array.isArray(currentCookies)) {
          currentCookies = !currentCookies ? [] : [String(currentCookies)];
        }
        _res.setHeader("Set-Cookie", currentCookies.concat(cookieStr));
        if (_req && _req.cookies) {
          const _cookies = _req.cookies;
          data === "" ? delete _cookies[key] : _cookies[key] = this.stringify(data);
        }
        if (_req && _req.headers && _req.headers.cookie) {
          const _cookies = (0, import_cookie.parse)(_req.headers.cookie);
          data === "" ? delete _cookies[key] : _cookies[key] = this.stringify(data);
          _req.headers.cookie = Object.entries(_cookies).reduce(
            (accum, item) => {
              return accum.concat(`${item[0]}=${item[1]};`);
            },
            ""
          );
        }
      }
    } else {
      document.cookie = cookieStr;
    }
  }
  async getCookie(key, options) {
    const _cookies = await this.getCookies(options);
    const value = _cookies[key];
    if (value === void 0) {
      return void 0;
    }
    return this.processValue(this.decode(value));
  }
  async deleteCookie(key, options) {
    this.setCookie(key, "", { ...options, maxAge: -1 });
  }
};

// src/library/Guid.ts
var Guid = class {
  static NewGuid = (noHyphens) => {
    var d = (/* @__PURE__ */ new Date()).getTime();
    if (typeof performance !== "undefined" && typeof performance.now === "function") {
      d += performance.now();
    }
    var shell = noHyphens ? "xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx" : "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx";
    return shell.replace(/[xy]/g, function(c) {
      var r = (d + Math.random() * 16) % 16 | 0;
      d = Math.floor(d / 16);
      return (c === "x" ? r : r & (3 | 8)).toString(16);
    });
  };
  static Empty = "00000000-0000-0000-0000-000000000000";
  static IsGuid = (guid) => /^([0-9a-fA-F]{8})-(([0-9a-fA-F]{4}-){3})([0-9a-fA-F]{12})$/i.test(guid);
};

// src/constants/defaultRedactionRules.ts
var defaultJsonRedactionText = "[REDACTED]";
var defaultUrlRedactionText = "REDACTED";
var defaultRedactionRules = {
  includes: [{ value: "password" }],
  properties: [
    { value: "token" },
    { value: "accessToken" },
    { value: "apiToken" },
    { value: "previewToken" },
    { value: "apiKey" },
    { value: "apiSecret" },
    { value: "clientId" },
    { value: "clientSecret" },
    { value: "secret" },
    { value: "metaData" }
  ],
  jsonRedactionText: defaultJsonRedactionText,
  urlRedactionText: defaultUrlRedactionText
};

// src/library/RedactionHandler.ts
var RedactionHandler = class {
  paths;
  properties;
  whitelistPaths;
  includes;
  jsonRedactionText;
  urlRedactionText;
  constructor(config) {
    this.paths = config.paths ?? [];
    this.properties = config.properties ?? [];
    this.whitelistPaths = config.whitelistPaths ?? [];
    this.includes = config.includes ?? [];
    this.jsonRedactionText = config.jsonRedactionText ?? defaultJsonRedactionText;
    this.urlRedactionText = config.urlRedactionText ?? defaultUrlRedactionText;
  }
  redact(data, currentPath) {
    if (typeof data === "string" || typeof data === "number" || typeof data === "boolean") {
      if (!currentPath) {
        console.warn(
          "Value passed to redact is a basic type, only objects can be redacted."
        );
        return data;
      } else {
        if (this.shouldRedact(currentPath)) {
          return this.jsonRedactionText;
        }
        if (typeof data === "string" && isValidUrl(data)) {
          return this.redactUrl(data);
        }
        return data;
      }
    } else if (typeof data === "object") {
      if (Array.isArray(data)) {
        return data.map(
          (datum) => this.redact(datum, currentPath)
        );
      } else if (data) {
        Object.keys(data).forEach((key) => {
          data[key] = this.redact(
            data[key],
            currentPath ? `${currentPath}.${key}` : key
          );
        });
      }
    }
    return data;
  }
  redactUrl(inputUrl) {
    const url = new URL(inputUrl);
    const urlParams = new URLSearchParams(url.search);
    for (let [key] of urlParams.entries()) {
      if (this.shouldRedact(this.urlQueryKeyToObjectPath(key))) {
        urlParams.set(key, this.urlRedactionText);
      }
    }
    url.search = urlParams.toString();
    return url.toString();
  }
  // assumes keys of string only
  urlQueryKeyToObjectPath(urlQueryKey) {
    let urlQueryKeyOpenBracketSplit = urlQueryKey.split("[");
    if (urlQueryKeyOpenBracketSplit.length === 1) {
      return urlQueryKey;
    } else {
      let objectPath = urlQueryKeyOpenBracketSplit.splice(
        0,
        1
      )[0];
      urlQueryKeyOpenBracketSplit.forEach((openBracketSplitValue, n) => {
        const closeBracketSplit = openBracketSplitValue.split("]");
        if (closeBracketSplit.length !== 2) {
          console.warn(
            `Object in URL params in incorrect format: [${urlQueryKeyOpenBracketSplit[n]}`
          );
          return;
        } else {
          if (closeBracketSplit[0].match(/^-?\d+$/)) {
            return;
          } else {
            objectPath += `.${closeBracketSplit[0]}`;
          }
        }
      });
      return objectPath;
    }
  }
  shouldRedact(path) {
    let ruleIsSatisfied = this.testRedactionRules(
      path,
      this.whitelistPaths
    );
    if (ruleIsSatisfied) {
      return false;
    }
    ruleIsSatisfied = this.testRedactionRules(path, this.paths);
    if (ruleIsSatisfied) {
      return true;
    }
    const properties = path.split(".");
    const propertyName = properties[properties.length - 1];
    ruleIsSatisfied = this.testRedactionRules(
      propertyName,
      this.properties
    );
    if (ruleIsSatisfied) {
      return true;
    }
    for (let n = 0; n < this.includes.length; n++) {
      if (propertyName.includes(this.includes[n].value) || !this.includes[n].caseSensitive && propertyName.toLowerCase().includes(this.includes[n].value.toLowerCase())) {
        n = this.includes.length;
        ruleIsSatisfied = true;
      }
    }
    return ruleIsSatisfied;
  }
  testRedactionRules(path, rules) {
    let ruleIsSatisfied = false;
    for (let n = 0; n < rules.length; n++) {
      if (path === rules[n].value || !rules[n].caseSensitive && path.toLowerCase() === rules[n].value.toLowerCase()) {
        n = rules.length;
        ruleIsSatisfied = true;
      }
    }
    return ruleIsSatisfied;
  }
};

// src/library/SDK.ts
var SDK = class extends EventManager {
  _hasBeenConfigured;
  _actionQueue;
  _endpoint;
  _locale;
  _currency;
  _extensionVersion;
  _useCurrencyInLocale;
  _sessionLifetime;
  _customHeaderValue;
  setEndpoint(url) {
    url = normaliseUrl(url);
    if (url.indexOf("http") === -1) {
      url = `https://${url}`;
      console.warn(
        `Protocol not supplied to endpoint, defaulting to https - ${url}`
      );
    }
    this._endpoint = url.split("/frontastic")[0];
  }
  /**
   * A function returning the full url endpoint to be called, to be set within the {@link configure} method.
   */
  endpoint() {
    return this._endpoint;
  }
  /**
   * A function returning the [BCP 47 language tag](http://tools.ietf.org/html/rfc5646) locale, to be set within the {@link configure} method.
   *
   * [MDN](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl#locales_argument).
   */
  locale() {
    return this._locale;
  }
  apiHubLocale() {
    const apiFormattedLocale = this._locale.replace("-", "_");
    if (this._useCurrencyInLocale) {
      return `${apiFormattedLocale}@${this._currency}`;
    } else {
      return apiFormattedLocale;
    }
  }
  /**
   * A function returning the string representing the ISO 4217 3-Letter Currency Code, to be set within the {@link configure} method.
   */
  currency() {
    return this._currency;
  }
  /**
   * A function returning the string optionally set within the {@link configure} method, the value to assign to a "coFE-Custom-Configuration" header value in every API call. Overriden on single calls by explicity set customHeaderValue passed in {@link callAction} and {@link PageApi} methods.
   */
  customHeaderValue() {
    return this._customHeaderValue;
  }
  constructor() {
    super();
    this._hasBeenConfigured = false;
    this._actionQueue = new Queue();
  }
  throwIfNotConfigured() {
    if (!this._hasBeenConfigured) {
      throw new Error(SDK_NOT_CONFIGURED_ERROR_MESSAGE);
    }
  }
  isRedactionManager(config) {
    return Boolean(
      config?.redact && config?.redactUrl
    );
  }
  /**
   * The method that must be called prior to any other methods to configure the connection to the backend. An error is throw if not called prior.
   *
   * @param {string} config.locale - A string representing the combination of the ISO 639-1 language and ISO 3166-1 country code. For example "en-DE" or "en_DE".
   * @param {string} config.currency - A string representing the ISO 4217 3-Letter Currency Code, for example EUR.
   * @param {string} config.endpoint - A string representing the full URL of the endpoint to be called.
   * @param {string} config.extensionVersion - A string representing the next public extension build ID, to specify the extension version in which to connect.
   * @param {boolean} [config.useCurrencyInLocale=false] - An optional boolean, default false. To be set to true if currency is required in config.locale, for example en-GB@EUR.
   * @param {string} [config.sessionLifetime=7776000000] - An optional number of milliseconds in which to persist the session lifeTime, to override the {@link DEFAULT_SESSION_LIFETIME} of 3 months.
   * @param {boolean} [options.customHeaderValue] - An optional string, the value to assign to a "coFE-Custom-Configuration" header value in every API call. Overriden on single calls by explicity set customHeaderValue passed in {@link callAction} and {@link PageApi} methods.
   * @param {CookieManager} [config.cookieHandlingOverride] - An optional cookie manager interface that contains all the cookie handling methods.
   * @param {RedactionManager | RedactionManagerConfig} [config.redactionHandlingOverride] - An optional class/object implementing the {@link RedactionManager} interface or {@link RedactionManagerConfig} to replace the default {@link defaultRedactionRules} passed to the inbuilt {@link RedactionHandler}.
   *
   * @returns {void} Void.
   */
  configure(config) {
    dependencyContainer().configure({
      cookieHandler: config.cookieHandlingOverride ?? new CookieHandler(),
      redactHandler: this.isRedactionManager(
        config.redactionHandlingOverride
      ) ? config.redactionHandlingOverride : new RedactionHandler(
        config.redactionHandlingOverride ?? defaultRedactionRules
      )
    });
    this.setEndpoint(config.endpoint);
    this.configureLocale(config);
    this._useCurrencyInLocale = config.useCurrencyInLocale ?? false;
    this._extensionVersion = config.extensionVersion;
    this._sessionLifetime = config.sessionLifetime ?? DEFAULT_SESSION_LIFETIME;
    this._customHeaderValue = config.customHeaderValue;
    this._hasBeenConfigured = true;
  }
  /**
   * The method called to standardise the locale and currency inputs.
   *
   * @param {string} config.locale - A string representing the combination of the ISO 639-1 language and ISO 3166-1 country code. For example en-GB or en_GB.
   * @param {string} config.currency - A string representing the ISO 3-Letter Currency Code, for example EUR.
   *
   * @returns {void} Void.
   */
  configureLocale(config) {
    const [locale, currency] = config.locale.split("@");
    if (currency) {
      this._currency = currency;
    }
    if (config.currency) {
      this._currency = config.currency;
    }
    this._locale = locale.replace(/_/g, "-");
  }
  handleApiCall(options) {
    let clonedOptions = JSON.parse(JSON.stringify(options));
    [
      clonedOptions.type === "pageAPI" ? "pageApiMethodCalled" : "actionCalled",
      "fetchCalled"
    ].forEach((eventName) => {
      const type = eventName === "fetchCalled" ? { type: clonedOptions.type } : {};
      this.trigger(
        // @ts-ignore
        new Event({
          eventName,
          data: Object.assign(
            clonedOptions.type === "pageAPI" ? { method: clonedOptions.method } : { actionName: clonedOptions.actionName },
            {
              ...type,
              parameters: dependencyContainer().redactHandler().redact(clonedOptions.parameters),
              url: dependencyContainer().redactHandler().redactUrl(clonedOptions.url),
              tracing: clonedOptions.tracing
            }
          )
        })
      );
    });
  }
  handleSuccesfulCall(options) {
    let clonedOptions = JSON.parse(JSON.stringify(options));
    [
      clonedOptions.type === "pageAPI" ? "pageApiFetchSuccessful" : "actionFetchSuccessful",
      "fetchSuccessful"
    ].forEach((eventName) => {
      const type = eventName === "fetchSuccessful" ? { type: clonedOptions.type } : {};
      this.trigger(
        // @ts-ignore
        new Event({
          eventName,
          data: Object.assign(
            clonedOptions.type === "pageAPI" ? { method: clonedOptions.method } : { actionName: clonedOptions.actionName },
            {
              ...type,
              parameters: dependencyContainer().redactHandler().redact(clonedOptions.parameters),
              url: dependencyContainer().redactHandler().redactUrl(clonedOptions.url),
              dataResponse: dependencyContainer().redactHandler().redact(clonedOptions.dataResponse),
              tracing: clonedOptions.tracing
            }
          )
        })
      );
    });
  }
  handleError(options) {
    [
      options.type === "action" ? "actionErrorCaught" : "pageApiErrorCaught",
      "errorCaught"
    ].forEach((eventName) => {
      const type = eventName === "errorCaught" ? { type: options.type } : {};
      this.trigger(
        // @ts-ignore
        new Event({
          eventName,
          data: Object.assign(
            options.type === "action" ? { actionName: options.actionName } : { method: options.method },
            {
              ...type,
              parameters: dependencyContainer().redactHandler().redact(
                JSON.parse(
                  JSON.stringify(options.parameters)
                )
              ),
              url: dependencyContainer().redactHandler().redactUrl(options.url),
              tracing: options.tracing,
              error: options.error
            }
          )
        })
      );
    });
    return {
      isError: true,
      tracing: options.tracing,
      error: options.error
    };
  }
  getDefaultAPIHeaders(customHeaderValue) {
    const customValue = customHeaderValue ?? this._customHeaderValue;
    const customHeader = customValue ? { "coFE-Custom-Configuration": customValue } : {};
    return {
      "Frontastic-Locale": this.apiHubLocale(),
      "Frontastic-Currency": this._currency,
      "Commercetools-Frontend-Extension-Version": this._extensionVersion,
      ...customHeader
    };
  }
  /**
   * The method used to call extension actions.
   *
   * @param {string} options.actionName - The name of the action corresponding to the location of the extension, for example "product/getProduct".
   * @param {unknown} [options.payload] - An optional key, value pair object payload to be serialised into the body of the request.
   * @param {Object.<string, number, boolean, string[], number[], boolean[]>} [options.query] - An optional key, value pair object to be serialised into the url query.
   * @param {boolean} [options.parallel] - An optional boolean, default true indicating whether the action should executed asyncronously or be added to a queue and executed in sequence. Useful to supply false on actions you may think have race conditions.
   * @param {string} [options.customHeaderValue] - An optional string, the value to assign to a "coFE-Custom-Configuration" header value. Overrides customHeaderValue passed in {@link configure}.
   * @param {Object} [options.serverOptions] - An optional object containing the res and req objects for ServerResponse and IncomingMessage with cookies respectively. Required for server-side rendering session management.
   *
   * @returns {PromiseLike<Object>} An object with a boolean isError property, and either an error or data property for true and false respectively. Type of data will match generic argument supplied to method.
   */
  async callAction(options) {
    this.throwIfNotConfigured();
    const params = options.query ? generateQueryString(options.query) : "";
    const fetcherOptions = {
      method: "POST",
      body: JSON.stringify(options.payload ?? {}),
      headers: this.getDefaultAPIHeaders(options.customHeaderValue)
    };
    let response;
    const url = normaliseUrl(
      `${this._endpoint}/frontastic/action/${options.actionName}${params}`
    );
    const action = () => fetcher(
      url,
      fetcherOptions,
      options.serverOptions,
      this._sessionLifetime
    );
    const frontendRequestId = Guid.NewGuid();
    this.handleApiCall({
      type: "action",
      actionName: options.actionName,
      parameters: {
        query: options.query,
        body: options.payload
      },
      url,
      tracing: {
        frontendRequestId
      }
    });
    try {
      if (options.parallel === false) {
        response = await this._actionQueue.add(action);
      } else {
        response = await action();
      }
    } catch (error) {
      return this.handleError({
        type: "action",
        parameters: {
          query: options.query,
          body: options.payload
        },
        url,
        actionName: options.actionName,
        tracing: {
          frontendRequestId,
          frontasticRequestId: ""
        },
        error: new ActionError({
          error
        })
      });
    }
    if (response.isError) {
      return this.handleError({
        type: "action",
        parameters: {
          query: options.query,
          body: options.payload
        },
        url,
        actionName: options.actionName,
        tracing: {
          frontendRequestId,
          frontasticRequestId: response.frontasticRequestId
        },
        error: new ActionError({
          error: response.error
        })
      });
    }
    this.handleSuccesfulCall({
      type: "action",
      actionName: options.actionName,
      parameters: {
        query: options.query,
        body: options.payload
      },
      url,
      dataResponse: response.data,
      tracing: {
        frontendRequestId,
        frontasticRequestId: response.frontasticRequestId
      }
    });
    return {
      isError: false,
      tracing: {
        frontendRequestId,
        frontasticRequestId: response.frontasticRequestId
      },
      data: response.data
    };
  }
  /**
   * The domain to call page methods on the API hub.
   */
  page = {
    getPage: async (options) => {
      this.throwIfNotConfigured();
      const params = options.query ? generateQueryString(options.query) : "";
      const fetcherOptions = {
        method: "POST",
        headers: {
          "Frontastic-Path": options.path,
          ...this.getDefaultAPIHeaders(options.customHeaderValue)
        }
      };
      let response;
      const url = normaliseUrl(
        `${this._endpoint}/frontastic/page${params}`
      );
      const frontendRequestId = Guid.NewGuid();
      this.handleApiCall({
        type: "pageAPI",
        method: "getPage",
        parameters: {
          query: options.query
        },
        url,
        tracing: {
          frontendRequestId
        }
      });
      try {
        response = await fetcher(
          url,
          fetcherOptions,
          options.serverOptions,
          this._sessionLifetime
        );
      } catch (error) {
        return this.handleError({
          type: "pageAPI",
          parameters: {
            query: options.query
          },
          url,
          method: "getPage",
          tracing: {
            frontendRequestId,
            frontasticRequestId: ""
          },
          error: new ActionError({
            error
          })
        });
      }
      if (response.isError) {
        return this.handleError({
          type: "pageAPI",
          parameters: {
            query: options.query
          },
          url,
          method: "getPage",
          tracing: {
            frontendRequestId,
            frontasticRequestId: response.frontasticRequestId
          },
          error: new ActionError({
            error: response.error
          })
        });
      }
      this.handleSuccesfulCall({
        type: "pageAPI",
        method: "getPage",
        parameters: {
          query: options.query
        },
        url,
        dataResponse: response.data,
        tracing: {
          frontendRequestId,
          frontasticRequestId: response.frontasticRequestId
        }
      });
      return {
        isError: false,
        tracing: {
          frontendRequestId,
          frontasticRequestId: response.frontasticRequestId
        },
        data: response.data
      };
    },
    getPreview: async (options) => {
      this.throwIfNotConfigured();
      const fetcherOptions = {
        method: "POST",
        headers: this.getDefaultAPIHeaders(options.customHeaderValue)
      };
      let response;
      const query = {
        previewId: options.previewId,
        locale: this.apiHubLocale()
      };
      const url = normaliseUrl(
        `${this._endpoint}/frontastic/preview${generateQueryString(
          query
        )}`
      );
      const frontendRequestId = Guid.NewGuid();
      this.handleApiCall({
        type: "pageAPI",
        method: "getPreview",
        parameters: {
          query
        },
        url,
        tracing: {
          frontendRequestId
        }
      });
      try {
        response = await fetcher(
          url,
          fetcherOptions,
          options.serverOptions,
          this._sessionLifetime
        );
      } catch (error) {
        return this.handleError({
          type: "pageAPI",
          parameters: {
            query
          },
          url,
          method: "getPreview",
          tracing: {
            frontendRequestId,
            frontasticRequestId: ""
          },
          error: new ActionError({
            error
          })
        });
      }
      if (response.isError) {
        return this.handleError({
          type: "pageAPI",
          parameters: {
            query
          },
          url,
          method: "getPreview",
          tracing: {
            frontendRequestId,
            frontasticRequestId: response.frontasticRequestId
          },
          error: new ActionError({
            error: response.error
          })
        });
      }
      this.handleSuccesfulCall({
        type: "pageAPI",
        method: "getPreview",
        parameters: {
          query
        },
        url,
        dataResponse: response.data,
        tracing: {
          frontendRequestId,
          frontasticRequestId: response.frontasticRequestId
        }
      });
      return {
        isError: false,
        tracing: {
          frontendRequestId,
          frontasticRequestId: response.frontasticRequestId
        },
        data: response.data
      };
    },
    getPages: async (options = {
      depth: 16,
      types: "static"
    }) => {
      this.throwIfNotConfigured();
      options.depth = options.depth ?? 16;
      options.types = options.types ?? "static";
      const fetcherOptions = {
        method: "POST",
        headers: this.getDefaultAPIHeaders(options.customHeaderValue)
      };
      let response;
      const query = {
        locale: this.apiHubLocale(),
        path: options.path ?? "",
        depth: options.depth
      };
      const url = normaliseUrl(
        `${this._endpoint}/frontastic/structure${generateQueryString(
          query
        )}`
      );
      const frontendRequestId = Guid.NewGuid();
      this.handleApiCall({
        type: "pageAPI",
        method: "getPages",
        parameters: {
          query
        },
        url,
        tracing: {
          frontendRequestId
        }
      });
      try {
        response = await fetcher(
          url,
          fetcherOptions,
          options.serverOptions,
          this._sessionLifetime
        );
      } catch (error) {
        return this.handleError({
          type: "pageAPI",
          parameters: {
            query
          },
          url,
          method: "getPages",
          tracing: {
            frontendRequestId,
            frontasticRequestId: ""
          },
          error: new ActionError({
            error
          })
        });
      }
      if (response.isError) {
        return this.handleError({
          type: "pageAPI",
          parameters: {
            query
          },
          url,
          method: "getPages",
          tracing: {
            frontendRequestId,
            frontasticRequestId: response.frontasticRequestId
          },
          error: new ActionError({
            error: response.error
          })
        });
      }
      this.handleSuccesfulCall({
        type: "pageAPI",
        method: "getPages",
        parameters: {
          query
        },
        url,
        dataResponse: response.data,
        tracing: {
          frontendRequestId,
          frontasticRequestId: response.frontasticRequestId
        }
      });
      return {
        isError: false,
        tracing: {
          frontendRequestId,
          frontasticRequestId: response.frontasticRequestId
        },
        data: response.data
      };
    }
  };
};

// src/library/PageError.ts
var PageError = class extends FetchError {
  /**
   * Constructor.
   *
   * @param {string | Error} options.error - The error returned from the internal fetcher.
   */
  constructor(options) {
    super(options);
  }
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  ActionError,
  CookieHandler,
  Event,
  FetchError,
  Integration,
  PageError,
  RedactionHandler,
  SDK,
  defaultRedactionRules,
  rememberMeCookie
});
//# sourceMappingURL=index.js.map